import _ from 'lodash';

export function getItem(key) {
    const value = window.localStorage.getItem(key);
    try {
        return JSON.parse(value);
    } catch (e) {
        return value;
    }
}

export function setItem(key, value) {
    if (_.isObject(value)) {
        value = JSON.stringify(value);
    }

    window.localStorage.setItem(key, value);
}
